import { Box, Link as MuiLink, type LinkProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TooltipContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  whiteSpace: "pre-wrap",
}));

export const LearnMoreLink = styled(MuiLink)<LinkProps>(({ theme }) => ({
  color: theme.palette.info.main,
  textDecoration: "none",
  cursor: "pointer",
}));
